import { render, staticRenderFns } from "./DayPauseListItem.vue?vue&type=template&id=58d8d548&scoped=true"
import script from "./DayPauseListItem.vue?vue&type=script&lang=js"
export * from "./DayPauseListItem.vue?vue&type=script&lang=js"
import style0 from "./DayPauseListItem.vue?vue&type=style&index=0&id=58d8d548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d8d548",
  null
  
)

export default component.exports